<template>
  <WhiteIQOS :title="$t('iiko_auto_settings.online_title')" :subtitle="$t('iiko_auto_settings.online_subtitle')" :enabled="fields.auto_close_online">
    <template #actions>
        <IQOSToggle v-model="fields.auto_close_online" />
    </template>

      <div class="gap-row-1xs" v-if="fields.auto_close_online">
        <div class="qrw-label-sm qrw-text-content-base-secondary">
            {{ $t('iiko_auto_settings.select_counterparty') }}
        </div>
        <BaseSelect
          v-model="fields.online_counterparty_id"
        >
            <option :value="null">
                {{ $t('iiko_auto_settings.none') }}
            </option>

          <option
            v-for="user in waiters"
            :key="user._id"
            :value="user.iiko_user_id"
          >
            {{ user.name }}
          </option>
        </BaseSelect>
      </div>
    </div>
  </WhiteIQOS>
</template>

<script>
export default {
  data() {
    return {
      fields: {},

      loaded: false
    };
  },
  watch: {
    fields: {
      handler() {
        if (!this.loaded) return;

        this.$store.commit('patchCafeGeneralData', {
            iiko: this.fields,
        });
        this.$store.dispatch('saveCafe');
      },
      deep: true,
    },
  },
  mounted() {
    this.fields = this.cafe.iiko;

    this.loaded = true;
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    waiters() {
      return this.$store.state.waiters;
    },
  },
};
</script>

<style scoped>
.setting-row {
  align-items: center;
}
</style>
